import { storeLocatorMapStyles } from '../const/store-locator.map-styles';

export const googleMapData = {
  brandColor: '#e61e25',
  height: '100%',
  width: '100%',
  zoom: 7,
  center: {
    lat: 47.411738,
    lng: 3.310441
  },
  options: {
    fullscreenControl: false,
    streetViewControl: false,
    mapTypeControl: false,
    styles: storeLocatorMapStyles
  },
  clusterOptions: {
    clusterColors: ['grey', '#e61e25', 'black'],
    svgClusterIcon:
      '<circle cx="120" cy="120" opacity=".6" r="70" />' +
      '<circle cx="120" cy="120" opacity=".4" r="95" /><circle cx="120" cy="120" opacity=".2" r="120" />',
    height: 40,
    width: 40,
    maxZoom: 6
  },
  markers: []
};
